import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { Router } from '@angular/router';
import {
  TranslationService,
  PickerLanguage,
} from '../../services/translation.service';
import { MarketService } from '../../services/market.service';
import { TranslatePipe } from '../../pipes/translate.pipe';

@Component({
  selector: 'app-language-switcher',
  standalone: true,
  imports: [CommonModule, MatIcon, MatMenuModule, TranslatePipe],
  templateUrl: './language-switcher.component.html',
  styleUrl: './language-switcher.component.scss',
})
export class LanguageSwitcherComponent {
  currentLanguage: PickerLanguage = 'en';

  constructor(
    private translationService: TranslationService,
    private marketService: MarketService,
    private router: Router
  ) {
    // Track the PICKER language (en | he | en-GB) so the active English variant
    // (US vs UK) highlights correctly.
    this.translationService.pickerLanguage$.subscribe((lang) => {
      this.currentLanguage = lang;
    });
  }

  // India (market=IN) is English-only — show a SINGLE neutral English option and
  // hide both Hebrew and English (UK), so the locale can never switch away from
  // en-IN.json (DMRA prohibition §3, spec B4). The resolver also forces en-IN for
  // any IN market, so even a stale/URL choice cannot escape.
  get isIndiaMarket(): boolean {
    return this.marketService.isIndia();
  }

  // The compact code shown on the trigger. India stays neutral 'EN' (never US/UK).
  get chipCodeKey(): string {
    if (this.isIndiaMarket) return 'miscUi.langCodeEnNeutral';
    if (this.currentLanguage === 'he') return 'miscUi.langCodeHe';
    if (this.currentLanguage === 'en-GB') return 'miscUi.langCodeGb';
    return 'miscUi.langCodeEn';
  }

  async changeLanguage(language: PickerLanguage) {
    console.log('LanguageSwitcherComponent: changing language to', language);

    await this.translationService.changeLanguage(language);

    // en-GB never appears in the URL — it rides on the /en segment.
    const urlLang = language === 'he' ? 'he' : 'en';
    const currentUrl = this.router.url;
    const urlSegments = currentUrl.split('/').filter((s) => s);

    if (
      urlSegments.length > 0 &&
      (urlSegments[0] === 'en' || urlSegments[0] === 'he')
    ) {
      urlSegments[0] = urlLang;
      await this.router.navigateByUrl('/' + urlSegments.join('/'));
    } else {
      await this.router.navigateByUrl(`/${urlLang}/${urlSegments.join('/')}`);
    }
  }
}
